import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/SupplierDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class SupplierEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/supplier/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class SupplierFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public code: IFieldOptions = { field: "code" };
	public taxCodeId: IFieldOptions = { field: "taxCodeId" };
	public name: IFieldOptions = { field: "name" };
	public sisproSupplierTimestamp: IFieldOptions = { field: "sisproSupplierTimestamp" };
	public sisproSupplierExtTimestamp: IFieldOptions = { field: "sisproSupplierExtTimestamp" };
	public sisproSupplierAddrTimestamp: IFieldOptions = { field: "sisproSupplierAddrTimestamp" };
	public sisproName: IFieldOptions = { field: "sisproName" };
	public sisproShortName: IFieldOptions = { field: "sisproShortName" };
	public branch: IFieldOptions = { field: "branch" };
	public contact: IFieldOptions = { field: "contact" };
	public telephone: IFieldOptions = { field: "telephone" };
	public fax: IFieldOptions = { field: "fax" };
	public email: IFieldOptions = { field: "email" };
	public beeRating: IFieldOptions = { field: "beeRating" };
	public beeExpiryDate: IFieldOptions = { field: "beeExpiryDate" };
	public beeCompanyRegistration: IFieldOptions = { field: "beeCompanyRegistration" };
	public companyRegNo: IFieldOptions = { field: "companyRegNo" };
	public address1: IFieldOptions = { field: "address1" };
	public address2: IFieldOptions = { field: "address2" };
	public address3: IFieldOptions = { field: "address3" };
	public address4: IFieldOptions = { field: "address4" };
	public address5: IFieldOptions = { field: "address5" };
	public addressContact: IFieldOptions = { field: "addressContact" };
	public postalAddress1: IFieldOptions = { field: "postalAddress1" };
	public postalAddress2: IFieldOptions = { field: "postalAddress2" };
	public postalAddress3: IFieldOptions = { field: "postalAddress3" };
	public postalAddress4: IFieldOptions = { field: "postalAddress4" };
	public postalAddress5: IFieldOptions = { field: "postalAddress5" };
	public postalAddressContact: IFieldOptions = { field: "postalAddressContact" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.code);
		this.push(this.taxCodeId);
		this.push(this.name);
		this.push(this.sisproSupplierTimestamp);
		this.push(this.sisproSupplierExtTimestamp);
		this.push(this.sisproSupplierAddrTimestamp);
		this.push(this.sisproName);
		this.push(this.sisproShortName);
		this.push(this.branch);
		this.push(this.contact);
		this.push(this.telephone);
		this.push(this.fax);
		this.push(this.email);
		this.push(this.beeRating);
		this.push(this.beeExpiryDate);
		this.push(this.beeCompanyRegistration);
		this.push(this.companyRegNo);
		this.push(this.address1);
		this.push(this.address2);
		this.push(this.address3);
		this.push(this.address4);
		this.push(this.address5);
		this.push(this.addressContact);
		this.push(this.postalAddress1);
		this.push(this.postalAddress2);
		this.push(this.postalAddress3);
		this.push(this.postalAddress4);
		this.push(this.postalAddress5);
		this.push(this.postalAddressContact);
	}
}

export class SupplierForm implements IFormOptions {
	protected supplierFormName: string = "supplierForm";
	protected supplierFormModel: models.SupplierDTO = new models.SupplierDTO();
	protected supplierFormEndPoints: SupplierEndPoints = new SupplierEndPoints();
	protected supplierFormFields: SupplierFormFields = new SupplierFormFields();
	public get name(): string { return this.supplierFormName };
	public get model(): models.SupplierDTO { return this.supplierFormModel };
	public get endPoints(): IEntityEndPoints { return this.supplierFormEndPoints };
       public set endPoints(supplierEndPoints: IEntityEndPoints) {
		this.supplierFormEndPoints = supplierEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): SupplierFormFields { return this.supplierFormFields };
}

export class SupplierListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public code: IColumnOptions = { field: "code" };
	public taxCodeId: IColumnOptions = { field: "taxCodeId" };
	public name: IColumnOptions = { field: "name" };
	public sisproSupplierTimestamp: IColumnOptions = { field: "sisproSupplierTimestamp" };
	public sisproSupplierExtTimestamp: IColumnOptions = { field: "sisproSupplierExtTimestamp" };
	public sisproSupplierAddrTimestamp: IColumnOptions = { field: "sisproSupplierAddrTimestamp" };
	public sisproName: IColumnOptions = { field: "sisproName" };
	public sisproShortName: IColumnOptions = { field: "sisproShortName" };
	public branch: IColumnOptions = { field: "branch" };
	public contact: IColumnOptions = { field: "contact" };
	public telephone: IColumnOptions = { field: "telephone" };
	public fax: IColumnOptions = { field: "fax" };
	public email: IColumnOptions = { field: "email" };
	public beeRating: IColumnOptions = { field: "beeRating" };
	public beeExpiryDate: IColumnOptions = { field: "beeExpiryDate", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public beeCompanyRegistration: IColumnOptions = { field: "beeCompanyRegistration" };
	public companyRegNo: IColumnOptions = { field: "companyRegNo" };
	public address1: IColumnOptions = { field: "address1" };
	public address2: IColumnOptions = { field: "address2" };
	public address3: IColumnOptions = { field: "address3" };
	public address4: IColumnOptions = { field: "address4" };
	public address5: IColumnOptions = { field: "address5" };
	public addressContact: IColumnOptions = { field: "addressContact" };
	public postalAddress1: IColumnOptions = { field: "postalAddress1" };
	public postalAddress2: IColumnOptions = { field: "postalAddress2" };
	public postalAddress3: IColumnOptions = { field: "postalAddress3" };
	public postalAddress4: IColumnOptions = { field: "postalAddress4" };
	public postalAddress5: IColumnOptions = { field: "postalAddress5" };
	public postalAddressContact: IColumnOptions = { field: "postalAddressContact" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.code);
		this.push(this.taxCodeId);
		this.push(this.name);
		this.push(this.sisproSupplierTimestamp);
		this.push(this.sisproSupplierExtTimestamp);
		this.push(this.sisproSupplierAddrTimestamp);
		this.push(this.sisproName);
		this.push(this.sisproShortName);
		this.push(this.branch);
		this.push(this.contact);
		this.push(this.telephone);
		this.push(this.fax);
		this.push(this.email);
		this.push(this.beeRating);
		this.push(this.beeExpiryDate);
		this.push(this.beeCompanyRegistration);
		this.push(this.companyRegNo);
		this.push(this.address1);
		this.push(this.address2);
		this.push(this.address3);
		this.push(this.address4);
		this.push(this.address5);
		this.push(this.addressContact);
		this.push(this.postalAddress1);
		this.push(this.postalAddress2);
		this.push(this.postalAddress3);
		this.push(this.postalAddress4);
		this.push(this.postalAddress5);
		this.push(this.postalAddressContact);
	}
}

export class SupplierList implements IGridOptions {
	protected supplierListName: string = "supplierList";
	protected supplierListModel: models.SupplierDTO = new models.SupplierDTO();
	protected supplierListEndPoints: SupplierEndPoints = new SupplierEndPoints();
	protected supplierListColumns: SupplierListColumns = new SupplierListColumns();
	public supplierForm: SupplierForm = new SupplierForm();
	public get name(): string { return this.supplierListName };
	public get model(): models.SupplierDTO { return this.supplierListModel };
	public get endPoints(): IEntityEndPoints { return this.supplierListEndPoints };
	public set endPoints(supplierEndPoints: IEntityEndPoints) {
		this.supplierListEndPoints = supplierEndPoints;
		this.supplierForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): SupplierListColumns { return this.supplierListColumns };
}

export class SupplierEntity implements IEntityOptions {
	protected supplierEntityName: string = "supplierEntity";
	protected supplierEntityModel: models.SupplierDTO = new models.SupplierDTO();
	protected supplierEntityEndPoints: SupplierEndPoints = new SupplierEndPoints();
	protected supplierEntityList: SupplierList = new SupplierList();
	public get name(): string { return this.supplierEntityName };
	public get model(): models.SupplierDTO { return this.supplierEntityModel };
	public get endPoints(): IEntityEndPoints { return this.supplierEntityEndPoints };
	public set endPoints(supplierEndPoints: IEntityEndPoints) {
		this.supplierEntityEndPoints = supplierEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): SupplierList { return this.supplierEntityList };
	public get form(): SupplierForm { return this.grid.supplierForm };
	constructor(name?: string) {
		if (name) this.supplierEntityName = name;
		this.endPoints = this.supplierEntityEndPoints;
	}
};
//export class SupplierGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: SupplierForm = new SupplierForm();
//};

//export class SupplierListPageComponent extends ListPageComponent {
  //protected listPageComponentList: SupplierList = new  SupplierList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class SupplierBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: SupplierGeneratedForm}];
//};

//export class SupplierListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: SupplierListPageComponent, isMenuHidden: true }];
//};

